import { DropDownBox } from '@apply/components';
import { EntityType, EntityTypeDescriptions } from '@apply/constants';
import { useBorrowerEntityTypeId } from '../../../../../../../queries/BorrowerFields/EntityFields';
import { CustomRule } from 'devextreme-react/validator';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';

interface ConfirmEntityProps {
    required?: boolean;
    readOnly?: boolean;
    isReview?: boolean;
}

export const ConfirmEntity: React.FC<ConfirmEntityProps> = ({ required = false, readOnly = false, isReview = false }) => {
    const label = 'Type of Entity';

    const [entityType, set_entityType] = useBorrowerEntityTypeId();

    const values = [
        { id: undefined, name: '' },
        { id: EntityType.LLC, name: EntityTypeDescriptions[EntityType.LLC] },
        { id: EntityType.Partnership, name: EntityTypeDescriptions[EntityType.Partnership] },
        { id: EntityType.SCorporation, name: EntityTypeDescriptions[EntityType.SCorporation] },
        { id: EntityType.CCorporation, name: EntityTypeDescriptions[EntityType.CCorporation] },
        { id: 'individual', name: 'N/A - held in name of individual' },
    ];

    const findEntityTypeById = (type?: number) => {
        return values.find((t) => t.id == type)?.name;
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={findEntityTypeById(entityType)}
                />
            ) : (
                <div style={{ marginTop: 16 }}>
                    <DropDownBox
                        id={'confirmEntityDropDown'}
                        value={entityType}
                        onChange={(value) => set_entityType(value)}
                        label={`Confirm ${label}`}
                        dataSource={values}
                        valueExpr='id'
                        displayExpr='name'
                        validator={
                            <CustomRule
                                validationCallback={(e) => e.value !== 'individual'}
                                message='Sorry, we do NOT make loans to individuals'
                            />
                        }
                        required={required}
                        readOnly={readOnly}
                    />
                </div>
            )}
        </>
    );
};
